<object [data]="fileData" width="100%" height="100%" type="application/pdf">

</object>
